"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStencil = exports.supportedStencilNames = void 0;
const shared_1 = require("@rb3ea-backend/shared");
exports.supportedStencilNames = [
    'apple-immersive-video',
    'artist',
    'athlete',
    'audio-clip',
    'author',
    'content-category',
    'content-collection',
    'content-hub',
    'collection',
    'country',
    'discipline',
    'editorial-list',
    'energy-drink',
    'episode-video',
    'event-details',
    'event-profile',
    'event-season',
    'event-series',
    'external-content-resource',
    'external-person',
    'external-team',
    'film',
    'geolocation',
    'image',
    'image-gallery',
    'immersive-3d-model',
    'judge',
    'live-video',
    'lsc',
    'misc',
    'occasion',
    'occasion-campaign',
    'onsite-promotion',
    'partner-profile',
    'photographer',
    'playground',
    'podcast-episode',
    'podcast-season',
    'podcast-show',
    'preview-clip',
    'project-profile',
    'rally-driver',
    'rally-team',
    'recap-video',
    'results-and-standings',
    'season',
    'show',
    'story',
    'team',
    'trailer-video',
    'tv-commercial',
    'tv-partner-channel',
    'video',
    'video-3d',
    'video-channel',
    'video-vr-360',
    'virtual-geolocation',
    'worldwide-geolocation',
];
const isStencil = (stencil) => {
    const stencilCast = stencil;
    return (0, shared_1.isDefined)(stencilCast.name)
        && (0, shared_1.isDefined)(stencilCast.content)
        && (0, shared_1.isDefined)(stencilCast.view)
        && (0, shared_1.isDefined)(stencilCast.roles)
        && (0, shared_1.isDefined)(stencilCast.spaces)
        && (0, shared_1.isDefined)(stencilCast.localizations);
};
exports.isStencil = isStencil;
const supportedStencilGroups = [
    'Audio',
    'Collections',
    'Editorial',
    'Events & Projects',
    'Experimental',
    'Images',
    'Misc.',
    'Moving images',
    'Persons & Groups',
    'Taxonomy',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RlbmNpbC5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2RlbHMvc3RlbmNpbHMvc3RlbmNpbC5tb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFNQSxrREFBaUQ7QUFTcEMsUUFBQSxxQkFBcUIsR0FBRztJQUNuQyx1QkFBdUI7SUFDdkIsUUFBUTtJQUNSLFNBQVM7SUFDVCxZQUFZO0lBQ1osUUFBUTtJQUNSLGtCQUFrQjtJQUNsQixvQkFBb0I7SUFDcEIsYUFBYTtJQUNiLFlBQVk7SUFDWixTQUFTO0lBQ1QsWUFBWTtJQUNaLGdCQUFnQjtJQUNoQixjQUFjO0lBQ2QsZUFBZTtJQUNmLGVBQWU7SUFDZixlQUFlO0lBQ2YsY0FBYztJQUNkLGNBQWM7SUFDZCwyQkFBMkI7SUFDM0IsaUJBQWlCO0lBQ2pCLGVBQWU7SUFDZixNQUFNO0lBQ04sYUFBYTtJQUNiLE9BQU87SUFDUCxlQUFlO0lBQ2Ysb0JBQW9CO0lBQ3BCLE9BQU87SUFDUCxZQUFZO0lBQ1osS0FBSztJQUNMLE1BQU07SUFDTixVQUFVO0lBQ1YsbUJBQW1CO0lBQ25CLGtCQUFrQjtJQUNsQixpQkFBaUI7SUFDakIsY0FBYztJQUNkLFlBQVk7SUFDWixpQkFBaUI7SUFDakIsZ0JBQWdCO0lBQ2hCLGNBQWM7SUFDZCxjQUFjO0lBQ2QsaUJBQWlCO0lBQ2pCLGNBQWM7SUFDZCxZQUFZO0lBQ1osYUFBYTtJQUNiLHVCQUF1QjtJQUN2QixRQUFRO0lBQ1IsTUFBTTtJQUNOLE9BQU87SUFDUCxNQUFNO0lBQ04sZUFBZTtJQUNmLGVBQWU7SUFDZixvQkFBb0I7SUFDcEIsT0FBTztJQUNQLFVBQVU7SUFDVixlQUFlO0lBQ2YsY0FBYztJQUNkLHFCQUFxQjtJQUNyQix1QkFBdUI7Q0FDZixDQUFBO0FBc0NILE1BQU0sU0FBUyxHQUFHLENBQUMsT0FBZ0IsRUFBMEIsRUFBRTtJQUNwRSxNQUFNLFdBQVcsR0FBRyxPQUFzQixDQUFBO0lBRTFDLE9BQU8sSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUM7V0FDN0IsSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxPQUFPLENBQUM7V0FDOUIsSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUM7V0FDM0IsSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxLQUFLLENBQUM7V0FDNUIsSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUM7V0FDN0IsSUFBQSxrQkFBUyxFQUFDLFdBQVcsQ0FBQyxhQUFhLENBQUMsQ0FBQTtBQUMzQyxDQUFDLENBQUE7QUFUWSxRQUFBLFNBQVMsYUFTckI7QUFFRCxNQUFNLHNCQUFzQixHQUFHO0lBQzdCLE9BQU87SUFDUCxhQUFhO0lBQ2IsV0FBVztJQUNYLG1CQUFtQjtJQUNuQixjQUFjO0lBQ2QsUUFBUTtJQUNSLE9BQU87SUFDUCxlQUFlO0lBQ2Ysa0JBQWtCO0lBQ2xCLFVBQVU7Q0FDWCxDQUFBIn0=